import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const taskCheckConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default taskCheckConfig;
